import { render, staticRenderFns } from "./SingleUsers.vue?vue&type=template&id=5360e9d0&"
import script from "./SingleUsers.vue?vue&type=script&lang=js&"
export * from "./SingleUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports